module.exports = __webpack_public_path__ + "static/media/img101.2b97dfd2.png";